module.exports = __webpack_public_path__ + "components/country-flag/static/ne-8d5af239925ebbba8f361feedef992af.svg";